/* TEBR motion layer — GSAP + ScrollTrigger, progressive enhancement.
   Hard rules for this theme (learned the hard way):
   - Horizon swaps the scroll container by viewport: wide = .page-wrapper
     (overflow-y:auto), narrow = the document. Detect it, never assume,
     and rebuild every trigger when a resize swaps it.
   - Never hide content in CSS that only JS reveals. All intro states are
     applied from JS, so a failed CDN load costs motion, not content. */
(function () {
  'use strict';

  function ready(fn) {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();
  }

  ready(function () {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add('tebr-motion');

    function scrollNode() {
      var pw = document.querySelector('.page-wrapper');
      if (pw) {
        var oy = getComputedStyle(pw).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw;
      }
      return null;
    }

    /* Intro: runs once, on whatever template loaded. from() means the
       resting state is the CSS state — nothing depends on this firing. */
    var hero = document.querySelector('.hero');
    if (hero) {
      var parts = hero.querySelectorAll('.lock, .hero__claim, .hero__foot');
      if (parts.length) {
        gsap.from(parts, {
          y: 26, opacity: 0, duration: 1.05, ease: 'power3.out',
          stagger: 0.12, delay: 0.1, clearProps: 'opacity,transform'
        });
      }
    }

    var bound = null;
    function build() {
      var sc = scrollNode() || window;
      if (bound === sc) { ScrollTrigger.refresh(); return; }
      bound = sc;

      ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
      gsap.set('.hero__img, .wr img', { clearProps: 'transform' });
      ScrollTrigger.defaults({ scroller: sc });

      /* Hero: slow push-in that settles as you leave the fold. */
      if (hero) {
        var img = hero.querySelector('.hero__img');
        if (img) {
          gsap.fromTo(img,
            { yPercent: -5, scale: 1.15 },
            { yPercent: 5, scale: 1.05, ease: 'none',
              scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        }
      }

      /* World panels: the image drifts against the scroll. Oversized so
         the drift never exposes the panel edge. */
      document.querySelectorAll('.wr').forEach(function (panel) {
        var img = panel.querySelector('img');
        if (!img) return;
        gsap.fromTo(img,
          { yPercent: -10, scale: 1.18 },
          { yPercent: 10, scale: 1.18, ease: 'none',
            scrollTrigger: { trigger: panel, start: 'top bottom', end: 'bottom top', scrub: true } });
      });

      /* Section headings: one quiet rise per band. */
      document.querySelectorAll('.b .d1, .b .d2').forEach(function (h) {
        gsap.from(h, {
          y: 34, opacity: 0, duration: 0.9, ease: 'power3.out',
          clearProps: 'opacity,transform',
          scrollTrigger: { trigger: h, start: 'top 88%', once: true }
        });
      });

      ScrollTrigger.refresh();
    }

    build();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(build, 250);
    }, { passive: true });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  });
})();
